import { render, staticRenderFns } from "./releaseDetail.vue?vue&type=template&id=79739cf4&scoped=true"
import script from "./releaseDetail.vue?vue&type=script&lang=js"
export * from "./releaseDetail.vue?vue&type=script&lang=js"
import style0 from "./releaseDetail.vue?vue&type=style&index=0&id=79739cf4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79739cf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79739cf4')) {
      api.createRecord('79739cf4', component.options)
    } else {
      api.reload('79739cf4', component.options)
    }
    module.hot.accept("./releaseDetail.vue?vue&type=template&id=79739cf4&scoped=true", function () {
      api.rerender('79739cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/release/releaseDetail.vue"
export default component.exports